import { Link } from 'react-router-dom';
import { Card, Typography, Tag, Space, Divider } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import './index.css';

const { Title, Text } = Typography;

const Archive = ({ posts }) => {
  // 按月份分组文章（兼容空数据）
  const groupByMonth = (posts) => {
    if (!posts || posts.length === 0) return {};
    
    const groups = {};
    posts.forEach(post => {
      // 兼容 createTime 格式，防止报错
      if (!post.createTime) return;
      const monthKey = post.createTime.split('-').slice(0, 2).join('年') + '月';
      if (!groups[monthKey]) groups[monthKey] = [];
      groups[monthKey].push(post);
    });
    return groups;
  };

  const groupedPosts = groupByMonth(posts);
  // 按时间倒序排列月份（最新的月份在前面）
  const sortedMonthKeys = Object.keys(groupedPosts).sort((a, b) => {
    // 提取年月进行比较
    const [aYear, aMonth] = a.replace(/年|月/g, '-').slice(0, -1).split('-');
    const [bYear, bMonth] = b.replace(/年|月/g, '-').slice(0, -1).split('-');
    return new Date(bYear, bMonth - 1) - new Date(aYear, aMonth - 1);
  });

  return (
    <div className="archive-page">
      <Title level={2} style={{ textAlign: 'center', marginBottom: '2rem' }}>
        文章归档
      </Title>

      {/* 空数据提示 */}
      {Object.keys(groupedPosts).length === 0 ? (
        <Card 
          className="archive-empty-card" 
          bordered={false} 
          style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}
        >
          <Text type="secondary" style={{ fontSize: '1rem' }}>
            暂无归档文章，快去 <Link to="/write">撰写文章</Link> 吧~
          </Text>
        </Card>
      ) : (
        <Card className="archive-card" bordered={false} style={{ maxWidth: 800, margin: '0 auto' }}>
          {sortedMonthKeys.map((month) => (
            <div key={month} className="month-section">
              {/* 月份标题 */}
              <div className="month-header">
                <CalendarOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                <Text strong style={{ fontSize: '1.1rem' }}>{month}</Text>
                <Text type="secondary" style={{ marginLeft: '0.5rem' }}>
                  （共 {groupedPosts[month].length} 篇）
                </Text>
              </div>
              <Divider style={{ margin: '0.5rem 0 1rem' }} />

              {/* 文章列表 */}
              <div className="post-list">
                {groupedPosts[month].map(post => (
                  <div key={post.id} className="post-item">
                    <Space.Compact style={{ width: '100%', alignItems: 'center' }}>
                      {/* 修复跳转链接：跳转到文章详情页 /post/:id */}
                      <Link to={`/post/${post.id}`} className="post-title">
                        <Text style={{ fontSize: '1rem' }}>{post.title}</Text>
                      </Link>
                      
                      <div className="post-meta">
                        {/* 日期 */}
                        <Text type="secondary" style={{ marginRight: 16 }}>
                          {post.createTime}
                        </Text>
                        {/* 适配多标签：循环展示所有标签 */}
                        <Space size="small">
                          {post.tags && post.tags.length > 0 ? (
                            post.tags.map(tag => (
                              <Tag key={tag} size="small" color="blue">
                                {tag}
                              </Tag>
                            ))
                          ) : (
                            <Tag size="small" color="gray">未分类</Tag>
                          )}
                        </Space>
                      </div>
                    </Space.Compact>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
};

export default Archive;